import { Outlet } from "react-router";

export default function LayoutFeedback() {
	return (
		<main className="py-24 bg-[#fafafa] min-h-screen">
			<Outlet />
		</main>
	);
}
